import React from 'react'
import { useEffect, useState } from 'react';
import './FaultSecondPageCustom_Coral.css';
import Chart from 'chart.js/auto';
import { Line } from "react-chartjs-2";
import * as $ from 'jquery';
import moment from 'moment';

import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';
import NoData_Coral from '../../Driveanalysis_Coral/NoData_Coral';
import ChartLoader_Coral from '../../Driveanalysis_Coral/ChartLoader_Coral';
import WaterMark from '../../DashboardMain_Coral/WaterMark';
import 'chartjs-plugin-datalabels';

export default function FaultSecondPageCharts_Coral(props) {
    let temp = [];
    function datesArray(start, end) {
        let result = [], current = new Date(start);
        while (current <= end)
            result.push(current) && (current = new Date(current)) && current.setDate(current.getDate() + 1);
        for (let i = 0; i < result.length; i++) {
            temp.push(
                result[i].toISOString().slice(0, 10)
            );
        }
        return temp;
    }

    const getMonths = (fromDate, toDate) => {
        const fromYear = fromDate.getFullYear();
        let fromMonth = fromDate.getMonth();
        const toYear = toDate.getFullYear();
        let toMonth = toDate.getMonth();
        const months = [];

        for (let year = fromYear; year <= toYear; year++) {
            let monthNum = year === fromYear ? fromMonth : 0;
            const monthLimit = year === toYear ? toMonth : 11;
            for (; monthNum <= monthLimit; monthNum++) {
                let month = monthNum + 1;
                month = month < 10 ? '0' + month : '' + month
                year = year.toString()
                let yeamon = year.concat(month);
                months.push(yeamon);
            }
        }
        return months;
    }

    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [falutTriggerParams, setFaultTriggerParams] = useState([]);
    const [faultSelected, setFaultSelected] = useState('day')
    const [falutTrigger, setFaultTrigger] = useState({
        labels: [],
        datasets: [],
        options: {
            plugins: {
                datalabels: {
                    display: false,
                },
                tooltip: {
                    enabled: true // Disable tooltip
                }
            },
            scales: {
                y: {
                    grid: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: "Fault count"
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: "Month"
                    }
                }
            },
            maintainAspectRatio: false,
        }
    });
    const [LineContainerBody, setCssLineCont] = useState({ height: "375px", });//360px

    function getMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString('en-US', { month: 'short' });
    }

    const responceData = (dataRes) => {
        let defaultArr = [];
        let colorArr = ["#3588A6", "#71BDDD", "#F39530", "#00866E", "#002942", "#F9F871"]
        // #3588A6#00A4B3#13C0AF#62D89C#ABEB83#F9F871
        for (let m = 0; m < falutTriggerParams.length; m++) {
            defaultArr.push({ label: falutTriggerParams[m], data: [], fill: false, borderColor: colorArr[m] })
        }

        let st = moment(new Date(props.gloablfilter.startDate)).format("YYYY-MM-DD");
        let ed = moment(new Date(props.gloablfilter.endDate)).format("YYYY-MM-DD")
        const dateArr = getMonths(new Date(st), new Date(ed));
        for (let q = 0; q < dateArr.length; q++) {
            dataRes.forEach((obj1) => {
                if (dateArr[q] === obj1.key.monthId) {
                    for (let t = 0; t < defaultArr.length; t++) {
                        if (defaultArr[t].label === obj1.key.ECU) {
                            defaultArr[t].data.push(obj1.occ.value)
                        }
                    }
                }
            })

            let count = 0;
            for (let pt = 0; pt < defaultArr.length; pt++) {
                if (defaultArr[pt].data.length > count) {
                    count = defaultArr[pt].data.length;
                }
            }

            for (let xt = 0; xt < defaultArr.length; xt++) {
                if (defaultArr[xt].data.length !== count) {
                    defaultArr[xt].data.push(0)
                }
            }
        }

        let monthArray = [];
        dataRes.map(({ key, i }) => {
            let year = key.monthId.substring(0, 4)
            let month = key.monthId.substring(4)
            let monthYear = getMonthName(month) + "-" + year
            monthArray.indexOf(monthYear) === -1 && monthArray.push(monthYear)
        })

        let totObj = { label: "Total", data: [], fill: false, borderColor: "#72d817" }
        for (let q = 0; q < defaultArr[0].data.length; q++) {
            let sum = 0;
            for (let index = 0; index < defaultArr.length; index++) {
                sum = sum + defaultArr[index].data[q];
            }
            totObj.data.push(sum)
        }
        defaultArr.push(totObj)

        const data = {
            labels: monthArray,
            datasets: defaultArr,
            options: {
                plugins: {
                    datalabels: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true // Disable tooltip
                    }
                },
                scales: {
                    y: {
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "Fault count"
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "Month"
                        }
                    }
                },
                maintainAspectRatio: false,
            }
        };
        setFaultTrigger(data)
    }

    function responceDataParam(dataParam) {
        if (dataParam.length > 0) {
            let paramArray = [];
            dataParam.forEach((obj1, index) => {
                paramArray.push(obj1.key.ECU);
            })
            setFaultTriggerParams(paramArray)
             console.log(paramArray);
        } else {
            setFaultTriggerParams([])
        }
    }
   

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultsTriggeredParams', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num:props.gloablfilter.vin_num } }, responceDataParam);
    }, [props])

    useEffect(() => {
        $("canvas").css('display', '');
        if (faultSelected === "month") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultsTriggered', body: { ECUparams: falutTriggerParams, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceData);
        } else {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultsTriggeredDate', body: { ECUparams: falutTriggerParams, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceDataDate);
        }
    }, [falutTriggerParams]);

    function responceDataDate(dataDate) {
        if (dataDate.length > 0) {
            let defaultArr = [];
            let colorArr = ["#3588A6", "#71BDDD", "#F39530", "#00866E", "#002942", "#F9F871"]
            for (let m = 0; m < falutTriggerParams.length; m++) {
                defaultArr.push({ label: falutTriggerParams[m], data: [], fill: false, borderColor: colorArr[m] })
            }
            const dateArr = datesArray(new Date(props.gloablfilter.startDate), new Date(props.gloablfilter.endDate));
            for (let q = 0; q < dateArr.length; q++) {
                dataDate.forEach((obj1) => {
                    if (dateArr[q] === obj1.key.eventdate) {
                        for (let t = 0; t < defaultArr.length; t++) {
                            if (defaultArr[t].label === obj1.key.ECU) {
                                defaultArr[t].data.push(obj1.occ.value)
                            }
                        }
                    }
                })

                let count = 0;
                for (let pt = 0; pt < defaultArr.length; pt++) {
                    if (defaultArr[pt].data.length > count) {
                        count = defaultArr[pt].data.length;
                    }
                }

                for (let xt = 0; xt < defaultArr.length; xt++) {
                    if (defaultArr[xt].data.length !== count) {
                        defaultArr[xt].data.push(0)
                    }
                }
            }
            let totObj = { label: "Total", data: [], fill: false, borderColor: "#72d817" }
            for (let q = 0; q < defaultArr[0].data.length; q++) {
                let sum = 0;
                for (let index = 0; index < defaultArr.length; index++) {
                    sum = sum + defaultArr[index].data[q];
                }
                totObj.data.push(sum)
            }
            defaultArr.push(totObj);
            let monthArrayD = [];

            dataDate.map(({ key, i }) => {
                monthArrayD.indexOf(key.eventdate) === -1 && monthArrayD.push(key.eventdate)
            })

            let aa = monthArrayD.sort((a, b) => new Date(a) - new Date(b));

            const data = {
                labels: monthArrayD,
                datasets: defaultArr,
                options: {
                    plugins: {
                        datalabels: {
                            display: false,
                        },
                        tooltip: {
                            enabled: true // Disable tooltip
                        }
                    },
                    scales: {
                        y: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: "Fault count"
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: "Day"
                            }
                        }
                    },
                    maintainAspectRatio: false,
                }
            };
            setFaultTrigger(data)
        } else {
            setFaultTrigger({
                labels: [],
                datasets: [],
                options: {
                    plugins: {
                        datalabels: {
                            display: false,
                        },
                        tooltip: {
                            enabled: true // Disable tooltip
                        }
                    },
                    scales: {
                        y: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: "Fault count"
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: "Month"
                            }
                        }
                    },
                    maintainAspectRatio: false,
                }
            });
        }
    }

    const changeFaultTrigger = (selectOp) => {
        setFaultSelected(selectOp);
        if (selectOp === "month") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultsTriggered', body: { ECUparams: falutTriggerParams, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceData);
        } else {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultsTriggeredDate', body: { ECUparams: falutTriggerParams, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceDataDate);
        }
    }

    return (
        <div className="col-md-12 col-lg-6 col-sm-12">
            <div className="v-title chartbox3">
                <div className="row mb-3">
                    <div className="col-md-12 col-sm-6 col-lg-8">
                        <div className="titlebg" id="sankalp">Faults Triggered</div>
                    </div>
                    <div className="col-md-12 col-sm-6 col-lg-4">
                        <select className="form-select form-select-sm" aria-label="Default select example" onChange={(event) => changeFaultTrigger(event.target.value)}
                            value={faultSelected}>
                            <option value="month">Month</option>
                            <option value="day">Day</option>
                        </select>
                    </div>
                </div>
                <div className="chartHGT">
                    <div style={{}}>
                        <WaterMark />
                        <div style={LineContainerBody} className='LineContainerBody'>
                            {(isLoading) ? <ChartLoader_Coral /> :
                                (falutTrigger.datasets.length > 0 ?
                                    <Line data={falutTrigger} options={falutTrigger.options} /> :
                                    <NoData_Coral />)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
